import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

const TourOverviewSkeleton = () => {
  const skeletonItems = Array.from({ length: 6 }, (_, i) => i);

  return (
    <Stack component="section" spacing={4}>
      {/* Two Column Layout */}
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}>
        {/* Left Column: 65% */}
        <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 65%" }, bgcolor: "background.warm_strong", p: 6 }}>
          <Stack spacing={2} mb={3}>
            {/* Title skeleton */}
            <Skeleton variant="text" width="40%" height={40} />
            {/* Summary skeleton - 4 lines */}
            <Stack spacing={1}>
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="85%" height={20} />
            </Stack>
          </Stack>

          <Stack spacing={3}>
            {/* Section heading */}
            <Skeleton variant="text" width="30%" height={28} />

            {/* Grid items */}
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 5 }}>
              {/* 6 skeleton items */}
              {skeletonItems.map((item) => (
                <Box
                  key={`left-skeleton-${item}`}
                  sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}
                >
                  {/* Icon circle */}
                  <Skeleton variant="circular" width={56} height={56} sx={{ flexShrink: 0 }} />
                  {/* Content */}
                  <Stack spacing={0.5} sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="80%" height={24} />
                    <Skeleton variant="text" width="100%" height={20} />
                  </Stack>
                </Box>
              ))}
            </Box>
          </Stack>
        </Box>

        {/* Right Column: 35% */}
        <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 35%" }, p: 4 }}>
          <Stack spacing={3}>
            {/* Essential Tour heading */}
            <Skeleton variant="text" width="70%" height={32} />

            {/* 6 content blocks */}
            {skeletonItems.map((item) => (
              <Stack key={`right-skeleton-${item}`} spacing={1}>
                <Skeleton variant="text" width="90%" height={24} />
                <Skeleton variant="text" width="100%" height={20} />
              </Stack>
            ))}

            {/* Button skeleton */}
            <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: "4px", mt: 2 }} />
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
};

export default TourOverviewSkeleton;
